export default __webpack_public_path__ + "static/media/quiz_bg_1.9489ec28.png";